var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3185 2.63491L10.3077 1.80452H9.47736C9.41935 1.80397 9.36134 1.80397 9.30333 1.80452C4.27251 1.85256 0.233139 5.96983 0.281186 11.0007C0.329233 16.0315 4.4465 20.0708 9.47732 20.0228C14.5058 20.0173 18.5809 15.9425 18.5869 10.9141V10.0837H10.3077L10.3185 2.63491Z",
    fill: "#8E97A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9849 0.146194V8.42451H20.2624C20.241 3.86174 16.5476 0.16803 11.9849 0.146194Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.9f6f9375ad2820ccfb4364bf3841b79c.svg";
export { ForwardRef as ReactComponent };